import styled, { css } from 'styled-components';
import { darken } from 'polished';
import MaterialDivider from '@material-ui/core/Divider';
import Button from '../../../../components/Button';

interface PauseSaleButtonProps {
  isPaused: boolean;
}

interface ButtonImgProps {
  img_url?: string;
}

export const AccordionTitle = styled.span`
  display: flex;
  align-items: center;

  div {
    h1 {
      font-weight: 500;
      font-size: 16px;
      color: #424242;
      margin-bottom: 3px;
    }
    /* Efeito para botão de subgrupo (não está em uso) */
    /* > button {
      position: relative;
      background: transparent;
      border: none;
      color: #1565c0;

      font-weight: 500;
      font-size: 13px;

      transition: all 0.35s ease-in-out;

      &:after {
        content: '';

        position: absolute;
        bottom: -5px;
        left: 1px;

        height: 1px;
        width: 0;

        background: #0d47a1;
        transition: width 0.35s ease-in-out;
      }

      &:hover::after {
        width: 100%;
      }

      &:hover {
        color: #0d47a1;
      }

      @media only screen and (max-width: 960px) {
        display: none;
      }
    } */
  }

  > button {
    background: transparent;
    height: 30px;
    width: 15px;
    border: none;
    margin-right: 10px;
    color: #616161;
    transition: all 0.25s ease-in-out;

    &:hover {
      transform: scale(1.15);
      color: #424242;
    }
  }
`;

export const ItemWrapper = styled.div<ButtonImgProps>`
  display: flex;
  align-items: center;

  span {
    font-weight: 500;
    color: #616161;
    font-size: 14px;
    max-width: 16vw;
    text-transform: uppercase;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  button {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    height: 42px;
    width: 42px;

    border: none;
    border-radius: 6px;
    margin-right: 18px;

    ${(props) =>
      props.img_url &&
      css`
        background-image: url(${props.img_url});
        background-size: cover;
        background-position: center;
      `}

    color: transparent;

    transition: all 0.35s ease-out;

    svg {
      z-index: 9;
    }

    &::after {
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;

      height: 42px;
      width: 42px;
      border-radius: 6px;
      background: transparent;
    }

    &:hover {
      color: #fff;
      box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.2);
    }

    &:hover::after {
      background: rgba(0, 0, 0, 0.15);
    }
  }
`;

export const SimpleTableText = styled.span`
  font-weight: 500;
  font-size: 14px;
  color: #616161;
`;

export const InputWrapper = styled.div`
  span {
    display: inline-block;
    margin-right: 5px;
    color: #424242;
  }

  input {
    padding: 4px;
    width: 60px;

    border-radius: 3px;
    border: 1px solid #757575;
    color: #212121;
  }
`;

export const InfoHeaderButton = styled.button`
  width: 14px;
  height: 14px;

  border-radius: 7px;
  border: none;
  margin-left: 8px;

  background: #1565c0;

  svg {
    margin-bottom: 2px;
    color: #fff;
  }
`;

export const StatusSaleButton = styled.button<PauseSaleButtonProps>`
  padding: 4px 8px;

  font-size: 12px;

  border: 1px solid #bdbdbd;
  background: #eee;
  color: #757575;

  transition: all 0.35s ease-in-out;

  &.activated {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  &.paused {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    border-right: none;
  }

  ${(props) =>
    !props.isPaused &&
    css`
      color: #fff;
      font-weight: 500;

      &.paused {
        background: #d32f2f;
        border: 1px solid #c62828;

        &:hover {
          background: #c62828;
          border-color: #b71c1c;
        }
      }

      &.activated {
        background: #1976d2;
        border: 1px solid #1565c0;

        &:hover {
          background: #1565c0;
          border-color: #0d47a1;
        }
      }
    `}

  ${(props) =>
    props.isPaused &&
    css`
      &:hover {
        background: #e0e0e0;
        border-color: #9e9e9e;
      }
    `}
    
  &:disabled {
    opacity: 0.5;
    cursor: default;
    
    &:hover {
      opacity: 0.5;
    }
  }
`;

export const ActionsOptionsButton = styled.button`
  width: 14px;
  height: 18px;

  background: none;
  border: none;

  color: #757575;

  transition: all 0.35s ease-in-out;

  &:hover {
    transform: scale(1.15);
    color: #212121;
  }
`;

export const SubmitButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const SubmitButton = styled(Button)`
  width: 235px;
  border-radius: 6px;
  height: 35px;
  margin: 0;

  &:disabled {
    border: 1px solid #bdbdbd;
    color: #bdbdbd;
    background: #f5f5f5 !important;
    cursor: not-allowed;
  }
`;

export const AddProductButton = styled(Button)`
  height: 35px;
  width: 100%;

  border-radius: 6px;
  margin-top: 4px;

  color: #01579b;
  background: transparent;
  border: 2px solid #01579b;

  transition: all 0.25s ease-in-out;

  &:hover {
    color: #fff;
    background: #01579b;
  }

  /* @media only screen and (max-width: 960px) {
    display: none;
  } */
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;

  height: inherit;
  margin-top: 10px;

  /* @media only screen and (max-width: 960px) {
    display: none;
  } */
`;

export const AmountDescription = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    span {
      font-size: 11px;
      color: #757575;
    }

    p {
      font-size: 13px;
      font-weight: 500;
      color: #424242;
    }
  }

  button {
    border: none;
    background: none;

    margin-right: 7px;
    color: #212121;
  }
`;

export const PriceWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    span {
      font-size: 11px;
      color: #757575;
    }

    p {
      font-size: 14px;
      font-weight: 500;
      color: #424242;
    }
  }
`;

export const ModalTitle = styled.h1`
  display: flex;
  justify-content: center;

  font-size: 22px;
  font-weight: 700;

  color: #212121;
`;

export const Divider = styled(MaterialDivider)`
  margin: 5px 0 -10px;
`;

export const GroupImgWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const AddButton = styled(Button)`
  width: 220px;
  height: 35px;

  border-radius: 6px;
  margin-top: 0;

  background: #0d47a1;
`;

export const ModalWrapper = styled.div`
  width: 280px;
  background: #fff;
  border-radius: 6px;
  padding: 10px 20px;

  div.header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    margin-bottom: 30px;

    > h1 {
      font-size: 26px;
      color: #212121;
    }

    > button {
      position: relative;
      background: transparent;
      border: none;
      color: #d32f2f;
      padding: 5px;
      border-radius: 15px;
      transition: all 0.35s ease-in-out;

      &:hover {
        color: #b71c1c;
        transform: scale(1.125);
      }
    }
  }

  div.description {
    margin-bottom: 30px;
    font-size: 15px;
  }

  div.btnActions {
    button {
      display: block;
      height: 35px;
      width: 100%;
      border-radius: 4px;

      margin-bottom: 7px;

      font-size: 14px;
      font-weight: 500;
      border: none;
      transition: all 0.35s ease-in-out;

      &.confirm {
        background: #1565c0;
        color: #fff;

        &:hover {
          background: #0d47a1;
        }

        &:disabled {
          border: 1px solid #757575;
          color: #757575;
          background: #f5f5f5 !important;
          cursor: not-allowed;
        }
      }

      &.cancel {
        border: 1px solid #1565c0;
        background: #fff;
        color: #1565c0;

        &:hover {
          color: #0d47a1;
          border: 1px solid #0d47a1;
        }
      }
    }
  }
`;

export const MenuOptionButton = styled.button`
  background: transparent;
  border: none;
  font-size: 15px;
  padding: 5px 0;
`;

export const ModalImgWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fff;

  border-radius: 6px;
  padding: 30px 30px 5px;

  div.img_wrapper {
    margin-bottom: 10px;

    img {
      border-radius: 6px;
      box-shadow: 0 0 8px rgba(0, 0, 0, 0.35);

      height: 400px;
      width: auto;
    }
  }

  div.divider {
    height: 1px;
    width: 100%;
    background: #e0e0e0;
    margin-bottom: 15px;
  }

  div.action {
    margin-bottom: 10px;
  }
`;

export const NewImg = styled.div`
  position: relative;
  width: 100%;
  margin-top: 5px;
  margin-bottom: 15px;

  img {
    border-radius: 4px;
    width: 100%;
    height: auto;

    border: 2px solid #fff;
    box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.35);
  }

  label {
    position: absolute;
    right: -3.5vh;
    bottom: -3.5vh;

    display: flex;
    justify-content: center;
    align-items: center;

    width: 42px;
    height: 42px;

    border-radius: 21px;
    border: none;
    color: #2979ff;
    cursor: pointer;

    transition: color 0.25s ease-in-out;

    &:hover {
      color: ${darken(0.075, '#2979ff')};
    }

    input {
      display: none;
    }
  }
`;
